<script lang="ts">
  export let url: string = '';
  export let text: string = '';
  export let background: string = 'gradient';
  export let layout: string = '';
  export let class_name: string = '';
  export let title: string = '';
  export let button_text: string = '';
  export let button_link: string = '';
  export let image_url: string = '';
  export let second_image_url: string = '';
</script>

{#if text}
  <section class="top-banner {background}">
    {#if url}
      <a href={url}>
        <p>{text}</p>
      </a>
    {:else}
      <p>{text}</p>
    {/if}
  </section>
{/if}

{#if layout == 'info_banner'}
  <section class="info-banner {class_name}">
    <div class="wrap">
      <div class="images">
        {#if image_url}
          <div class="image image-1">
            <img src={image_url} alt="" />
          </div>
        {/if}
        {#if second_image_url}
          <div class="image image-2">
            <img src={second_image_url} alt="" />
          </div>
        {/if}
      </div>
      <div class="content">
        {#if title}
          <h2>{title}</h2>
        {/if}
        {#if button_text && button_link}
          <a href={button_link} class="button">
            {button_text}
          </a>
        {/if}
      </div>
    </div>
  </section>
{/if}
